<template>

    <div>

        <div class="loading-container-mobile" v-if="isMobile()">
        
            <img :src="images.title" class="loading-title" />

            <div class="loading-info">

                加载中: {{ pct }}%

                <div style="width: 60%; margin-top: 1rem">
                    <va-progress-bar :size="20" :model-value="pct" />
                </div>
            </div>

            <Footer />
        </div>

        <Warning v-else />
    </div>
</template>

<script>

    import { toRefs, reactive, watch } from "vue";
    import { useRouter } from "vue-router";
    
    import Footer from "@/components/footer";
    import Warning from "@/components/warning";

    import HelperMixin from "@/mixins/helper";

    import ImageTitle from "@/assets/loading/title.png";
    
    export default {
        name: "Loading",
        components: {
            Footer,
            Warning
        },
        mixins: [ HelperMixin ],
        setup() {

            let count = 0;

            const imgs = [

                require("@/assets/loading/bg.jpg"),
                require("@/assets/loading/title.png"),
                require("@/assets/logo.png"),
                require("@/assets/info.png"),

                require("@/../public/puzzleimage/image-1/1.jpg"),
                require("@/../public/puzzleimage/image-1/1-1.png"),
                require("@/../public/puzzleimage/image-1/1-2.png"),
                require("@/../public/puzzleimage/image-1/img/1.jpg"),
                require("@/../public/puzzleimage/image-1/img/2.jpg"),
                require("@/../public/puzzleimage/image-1/img/3.jpg"),
                require("@/../public/puzzleimage/image-1/img/4.jpg"),
                require("@/../public/puzzleimage/image-1/img/5.jpg"),
                require("@/../public/puzzleimage/image-1/img/6.jpg"),
                require("@/../public/puzzleimage/image-1/img/7.jpg"),
                require("@/../public/puzzleimage/image-1/img/8.jpg"),
                require("@/../public/puzzleimage/image-1/img/9.jpg"),

                require("@/../public/puzzleimage/image-2/img/2.jpg"),
                require("@/../public/puzzleimage/image-2/2-1.png"),
                require("@/../public/puzzleimage/image-2/2-2.png"),
                require("@/../public/puzzleimage/image-2/img/1.jpg"),
                require("@/../public/puzzleimage/image-2/img/2.jpg"),
                require("@/../public/puzzleimage/image-2/img/3.jpg"),
                require("@/../public/puzzleimage/image-2/img/4.jpg"),
                require("@/../public/puzzleimage/image-2/img/5.jpg"),
                require("@/../public/puzzleimage/image-2/img/6.jpg"),
                require("@/../public/puzzleimage/image-2/img/7.jpg"),
                require("@/../public/puzzleimage/image-2/img/8.jpg"),
                require("@/../public/puzzleimage/image-2/img/9.jpg"),

                require("@/../public/puzzleimage/image-3/img/3.jpg"),
                require("@/../public/puzzleimage/image-3/3-1.png"),
                require("@/../public/puzzleimage/image-3/3-2.png"),
                require("@/../public/puzzleimage/image-3/img/1.jpg"),
                require("@/../public/puzzleimage/image-3/img/2.jpg"),
                require("@/../public/puzzleimage/image-3/img/3.jpg"),
                require("@/../public/puzzleimage/image-3/img/4.jpg"),
                require("@/../public/puzzleimage/image-3/img/5.jpg"),
                require("@/../public/puzzleimage/image-3/img/6.jpg"),
                require("@/../public/puzzleimage/image-3/img/7.jpg"),
                require("@/../public/puzzleimage/image-3/img/8.jpg"),
                require("@/../public/puzzleimage/image-3/img/9.jpg"),

                require("@/../public/puzzleimage/image-4/img/4.jpg"),
                require("@/../public/puzzleimage/image-4/4-1.png"),
                require("@/../public/puzzleimage/image-4/4-2.png"),
                require("@/../public/puzzleimage/image-4/img/1.jpg"),
                require("@/../public/puzzleimage/image-4/img/2.jpg"),
                require("@/../public/puzzleimage/image-4/img/3.jpg"),
                require("@/../public/puzzleimage/image-4/img/4.jpg"),
                require("@/../public/puzzleimage/image-4/img/5.jpg"),
                require("@/../public/puzzleimage/image-4/img/6.jpg"),
                require("@/../public/puzzleimage/image-4/img/7.jpg"),
                require("@/../public/puzzleimage/image-4/img/8.jpg"),
                require("@/../public/puzzleimage/image-4/img/9.jpg"),

                require("@/../public/puzzleimage/image-5/img/5.jpg"),
                require("@/../public/puzzleimage/image-5/5-1.png"),
                require("@/../public/puzzleimage/image-5/5-2.png"),
                require("@/../public/puzzleimage/image-5/img/1.jpg"),
                require("@/../public/puzzleimage/image-5/img/2.jpg"),
                require("@/../public/puzzleimage/image-5/img/3.jpg"),
                require("@/../public/puzzleimage/image-5/img/4.jpg"),
                require("@/../public/puzzleimage/image-5/img/5.jpg"),
                require("@/../public/puzzleimage/image-5/img/6.jpg"),
                require("@/../public/puzzleimage/image-5/img/7.jpg"),
                require("@/../public/puzzleimage/image-5/img/8.jpg"),
                require("@/../public/puzzleimage/image-5/img/9.jpg"),

                require("@/assets/share.jpg"),
                require("@/assets/title.png"),

                require("@/assets/card/bg-1.jpg"),
                require("@/assets/card/clipper.png"),
                require("@/assets/card/decoration-left.png"),
                require("@/assets/card/decoration-right.png"),
                require("@/assets/card/dialog-bg.png"),
                require("@/assets/card/dialog-reset-btn.png"),
                require("@/assets/card/dialog-start-btn.png"),
                require("@/assets/card/line-1.png"),
                require("@/assets/card/line-2.png"),
                require("@/assets/card/photo-base.png"),

                require("@/assets/home/button.png"),
                require("@/assets/home/home.jpg"),
                require("@/assets/home/logo.png"),
                require("@/assets/home/music.png"),
                require("@/assets/home/puzzle_rule_btn.png"),
                require("@/assets/home/title.png"),

                require("@/assets/puzzle/bg.jpg"),
                require("@/assets/puzzle/start-btn.png"),

                require("@/assets/puzzle/dialog/continue-btn.png"),
                require("@/assets/puzzle/dialog/emoji.png"),
                require("@/assets/puzzle/dialog/gradient.png"),
                require("@/assets/puzzle/dialog/like-bg.png"),
                require("@/assets/puzzle/dialog/like-btn.png"),
                require("@/assets/puzzle/dialog/like.png"),
                require("@/assets/puzzle/dialog/medal.png"),
                require("@/assets/puzzle/dialog/ribbon.png"),
                require("@/assets/puzzle/dialog/share-btn.png"),

                require("@/assets/puzzle/share-dialog/barcode.png"),
                require("@/assets/puzzle/share-dialog/poster.jpg"),
                require("@/assets/puzzle/share-dialog/return-btn.png"),

                require("@/assets/ruledialog/bg.png"),
                require("@/assets/ruledialog/cancel-btn.png")
            ];


            const router = useRouter();

            const state = reactive({
                images: {
                    title: ImageTitle
                },
                pct: 0
            });

            watch(state, newValue => {

                const { pct } = newValue;

                if(pct === 100) {

                    router.replace({
                        name: "Home"
                    });
                }
            });

            const loadingImage = () => {

                imgs.forEach(img => {

                    const image = new Image();

                    image.src = img;

                    image.onload = () => {

                        count++;

                        state.pct = parseInt(count / imgs.length * 100);
                    }
                });
            };

            return {
                ...toRefs(state),
                loadingImage
            };
        },
        mounted() {

            if(this.isMobile()) {
                this.loadingImage();
            }
        }
    };
</script>

<style lang="scss" scoped>

    .loading-container-mobile {

        background-image: url(../assets/loading/bg.jpg);
        background-position: 50% 50%;
        background-size: 100% 100%;
        height: 100vh;
        width: 100vw;

        .loading-title {
            width: 80%;
            position: fixed;
            left: 50%;
            top: 22%;
            transform: translate(-50%, -50%);
            -webkit-backface-visibility: hidden;
            backface-visibility:hidden;
            -webkit-background-clip:content-box;
        }

        .loading-info {
            position: fixed;
            top: 43%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-weight: 400;
            font-size: 14px;
            letter-spacing: 0.1rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
        }


    }

    .loading-container {

        background-color: #333333;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;

        .loading-tip-container {

            background-color: white;
            width: 22rem;
            height: 11.67rem;
            border-radius: 1rem;
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            font-weight: 400;
            font-family: Source Han Sans CN;

            .loading-tip-icon {
                position: absolute;
                // left: 45%;
                top: -12%;
                // transform: translate(-50%, -50%);
            }
        }
    }
</style>

<style lang="scss">

    .loading-container {

        .va-progress-bar__wrapper {
            border: 3px solid #57ACFF !important;
            background-color: #8CC5FF !important;
        }

        .va-progress-bar__progress {
            background: linear-gradient(
                -60deg, 
                #92F860 0, #92F860 5%, 
                #00C300 5%, #00C300 10%, 
                #92F860 10%, #92F860 15%, 
                #00C300 15%, #00C300 20%,
                #92F860 20%, #92F860 25%, 
                #00C300 25%, #00C300 30%,
                #92F860 30%, #92F860 35%,
                #00C300 35%, #00C300 40%,
                #92F860 40%, #92F860 45%,
                #00C300 45%, #00C300 50%,
                #92F860 50%, #92F860 55%, 
                #00C300 55%, #00C300 60%, 
                #92F860 60%, #92F860 65%, 
                #00C300 65%, #00C300 70%,
                #92F860 70%, #92F860 75%, 
                #00C300 75%, #00C300 80%,
                #92F860 80%, #92F860 85%,
                #00C300 85%, #00C300 90%,
                #92F860 90%, #92F860 95%,
                #00C300 95%, #00C300 100%
            );
            box-shadow: 0rem 1rem 1rem 0rem rgba(115, 219, 98, 0.45), 0rem -1rem 1rem 0rem rgba(115, 219, 98, 0.85);
        }
    }
</style>